import React from "react";
import { useContext, useRef } from "react";
// import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import CardBox from "components/ui/controls/card-box/card-box";
import InfoMessage from "components/ui/controls/info-message/info-message";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import { FaUpload } from "react-icons/fa";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import { AppContext } from "components/app/RemExprertProvider";
import { RGContext } from "./RGProvider";
import { OkMessage } from "components/ui/controls/info-message";
// import { ModalContext } from "components/ui/modal/modal-provider";

const LectureRG = (props) => {
  const context = useContext(AppContext);
  const RGCtx = useContext(RGContext);
  const fileInputRef = useRef(null);

  const handleFileUpload = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (evt) => {
    if (evt.target.files[0]) {
      RGCtx.handleUploadRG(context.state)(evt, evt.target.files[0]);
    }
  };
  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            <Row>
              <InfoMessage text="L'import du relevé du régime général permet d'intégrer réellement les revenus soumis à cotisations sociales au régime de base de la sécurité sociale. En effet, depuis le 1er juillet 2023, le RIS affiche les revenus réellement perçus, ce qui peut entrainer des erreurs sur des périodes à temps partiel notamment. Attention, il est indispensable dans un premier temps, d'importer le RIS pour que la correction s'applique." />
            </Row>
            <Row tpad>
              <input ref={fileInputRef} type="file" style={{ display: "none" }} onChange={handleFileChange} accept=".pdf" />
              <ActionButton
                onClick={handleFileUpload}
                icon={FaUpload}
                title="Importer un fichier"
                subtitle="Relevé du régime général"
                colors={{
                  primary: "#3b82f6",
                  secondary: "#1d4ed8",
                  shadow: "rgba(59, 130, 246, 0.4)",
                  shadowHover: "rgba(59, 130, 246, 0.6)",
                }}
                decorativeIcon={{ type: "upload" }}
              />
            </Row>
            {RGCtx.ErrorMessage !== "" && (
              <Row tpad>
                <blockquote style={{ borderLeft: "5px solid red" }}>{RGCtx.ErrorMessage}</blockquote>
              </Row>
            )}
            {RGCtx.SuccessMessage === true && (
              <>
                <Row>
                  <OkMessage text={<>Le relevé carrière de carrière a bien été importé.Vous pouvez modifier les revenus dans l'onglet "Carrière" si besoin.</>} />
                </Row>
                <Row tpad>
                  {/* Column headers for the list */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      maxWidth: 700,
                      margin: "8px 0 8px 0",
                      paddingLeft: 12,
                      fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                      fontSize: 13,
                      color: "#64748b",
                      fontWeight: 600,
                      letterSpacing: "-0.01em",
                    }}
                  >
                    <span style={{ minWidth: 80, marginRight: 18, textAlign: "center", padding: "4px 12px" }}>Année</span>
                    <span style={{ width: 200, marginRight: 18, textAlign: "center", display: "inline-block" }}>Période</span>
                    <span style={{ width: 230, marginRight: 18, textAlign: "center", display: "inline-block" }}>Revenu</span>
                    <span style={{ flex: 1 }}></span>
                  </div>
                </Row>
                <Row>
                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      width: "100%",
                      maxWidth: 700,
                      marginLeft: 0,
                      marginRight: 0,
                      display: "block",
                    }}
                  >
                    {RGCtx.ReleveCarriere?.map((infos, index) => {
                      return (
                        <React.Fragment key={index}>
                          <li
                            style={{
                              background: "#fff",
                              borderRadius: "12px",
                              boxShadow: "0 1px 4px rgba(99,102,241,0.06)",
                              padding: "8px 0 8px 12px",
                              marginBottom: "14px",
                              display: "flex",
                              alignItems: "center",
                              position: "relative",
                              border: "1.5px solid #d1d5db",
                              transition: "box-shadow 0.2s",
                            }}
                          >
                            <span
                              style={{
                                fontWeight: 700,
                                fontSize: "12px",
                                color: " #6366f1",
                                fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                                minWidth: 80,
                                marginRight: 18,
                                background: "#f1f5ff",
                                border: "1.5px solid #6366f1",
                                borderRadius: "8px",
                                padding: "4px 12px",
                                display: "inline-block",
                                textAlign: "center",
                              }}
                            >
                              {infos.annee}
                            </span>
                            <TextField style={{ width: "200px", marginRight: 18, textAlign: "center" }} disabled value={infos.periodes[0].libelle} />
                            <TextField style={{ width: "200px", marginRight: 18, textAlign: "center" }} disabled value={infos.periodes[0].revenu} />
                            <span style={{ flex: 1 }}></span>
                          </li>
                          {infos.periodes.length === 2 && (
                            <li
                              style={{
                                background: "#fff",
                                borderRadius: "12px",
                                boxShadow: "0 1px 4px rgba(99,102,241,0.06)",
                                padding: "8px 0 8px 12px",
                                marginBottom: "14px",
                                display: "flex",
                                alignItems: "center",
                                position: "relative",
                                border: "1.5px solid #d1d5db",
                                transition: "box-shadow 0.2s",
                              }}
                            >
                              <span style={{ minWidth: 80, marginRight: 18 }}></span>
                              <TextField style={{ width: "200px", marginRight: 18, textAlign: "center" }} disabled value={infos.periodes[1].libelle} />
                              <TextField style={{ width: "200px", marginRight: 18, textAlign: "center" }} disabled value={infos.periodes[1].revenu} />
                              <span style={{ flex: 1 }}></span>
                            </li>
                          )}
                          {infos.periodes.length === 3 && (
                            <li
                              style={{
                                background: "#fff",
                                borderRadius: "12px",
                                boxShadow: "0 1px 4px rgba(99,102,241,0.06)",
                                padding: "8px 0 8px 12px",
                                marginBottom: "14px",
                                display: "flex",
                                alignItems: "center",
                                position: "relative",
                                border: "1.5px solid #d1d5db",
                                transition: "box-shadow 0.2s",
                              }}
                            >
                              <span style={{ minWidth: 80, marginRight: 18 }}></span>
                              <TextField style={{ width: "200px", marginRight: 18, textAlign: "center" }} disabled value={infos.periodes[2].libelle} />
                              <TextField style={{ width: "200px", marginRight: 18, textAlign: "center" }} disabled value={infos.periodes[2].revenu} />
                              <span style={{ flex: 1 }}></span>
                            </li>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </ul>
                </Row>
              </>
            )}
          </Column>
        </CardBox>
      </Column>
    </>
  );
};
export default LectureRG;
